import {useEffect, useMemo, useState} from 'react'
import {useSettings} from '@wix/tpa-settings/react'
import isEqual from 'lodash/isEqual'

import {useReservationAddonStorage} from '../storage'
import {
  getEnabledReservationLocations,
  getInitialReservationLocation,
} from '../../../utils/reservationLocation'
import {settingsParams} from '../settingsParams'
import {DisplayConfig} from '../Settings/Tabs/Display/settingsParams'
import {useGetLayoutSize} from '../../../components-shared/LayoutSizeProvider'
import {useApproveTextView} from '../../../utils/useApproveTextView'
import {RequestStatus} from '../../../utils/wrapRequest'
import {getEffectiveFormLayout} from '../../Reservations/Widget/formLayout'

export const useHooks = () => {
  const {reservationLocations, approvalTextEditorState, getDayTimeSlotsStatus} =
    useReservationAddonStorage()
  const settings = useSettings()
  const {layoutSize, containerWidth} = useGetLayoutSize()

  const getTimeSlotsRequestFailed = getDayTimeSlotsStatus === RequestStatus.FAILED

  //  settings.get(settingsParams.displayConfig) returns new object on every call
  const displayConfigRaw = settings.get(settingsParams.displayConfig) as DisplayConfig
  const [displayConfig, setDisplayConfig] = useState(displayConfigRaw)

  useEffect(() => {
    setDisplayConfig((prevDisplayConfig) =>
      isEqual(prevDisplayConfig, displayConfigRaw) ? prevDisplayConfig : displayConfigRaw,
    )
  }, [displayConfigRaw])

  const enabledReservationLocations = useMemo(() => {
    let enabledLocations = getEnabledReservationLocations(reservationLocations)

    if (displayConfig.enabledLocations) {
      enabledLocations = enabledLocations.filter(
        (location) => displayConfig.enabledLocations?.includes(location.id!) ?? false,
      )
    }
    if (enabledLocations.length === 0 && reservationLocations[0]) {
      enabledLocations = [reservationLocations[0]]
    }

    return enabledLocations
  }, [reservationLocations, displayConfig])

  const {shouldShowAutoApproveText} = useApproveTextView(
    enabledReservationLocations,
    approvalTextEditorState,
  )

  const selectedReservationLocation = getInitialReservationLocation(enabledReservationLocations)
  const selectedReservationLocationId = selectedReservationLocation?.id
  const effectiveFormLayout = getEffectiveFormLayout({
    layoutSize,
    formLayout: settings.get(settingsParams.formLayout),
  })

  const shouldShowNoLocations = !selectedReservationLocationId

  const handleErrorClick = () => window.location.reload()

  return {
    layoutSize,
    containerWidth,
    enabledReservationLocations,
    shouldShowNoLocations,
    shouldShowAutoApproveText,
    getTimeSlotsRequestFailed,
    handleErrorClick,
    effectiveFormLayout,
  }
}
